import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { UserAvatar } from './UserAvatar'
import type { Friend } from '../types'

interface FriendRowProps {
  readonly friend: Friend
  readonly onRemove: (userId: string) => void
  readonly onBlock: (userId: string) => void
  readonly onReport: (friend: Friend) => void
}

export function FriendRow({ friend, onRemove, onBlock, onReport }: FriendRowProps) {
  const { t } = useTranslation()
  const name = friend.username ?? ''

  return (
    <li className="flex flex-wrap items-center gap-3 rounded-2xl bg-surface-low px-4 py-3">
      <UserAvatar username={friend.username} avatarUrl={friend.avatar_url} />

      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-semibold text-on-surface">{friend.username}</span>
        <span className="text-xs text-on-surface-variant">
          {t('social.friends.xp', { xp: friend.xp_total })}
        </span>
      </span>

      <span className="flex gap-1">
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onReport(friend)}
          aria-label={t('social.moderation.report_user', { username: name })}
        >
          {t('social.moderation.report')}
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onBlock(friend.id)}
          aria-label={t('social.moderation.block_user', { username: name })}
        >
          {t('social.moderation.block')}
        </Button>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => onRemove(friend.id)}
          aria-label={t('social.friends.remove_user', { username: name })}
        >
          {t('social.friends.remove')}
        </Button>
      </span>
    </li>
  )
}
